import { SeoPageLayout } from "@/components/SeoPageLayout";
import { SeoSection } from "@/components/seo/SeoSection";
import { SeoStyledList } from "@/components/seo/SeoStyledList";
import { SeoFeatureGrid } from "@/components/seo/SeoFeatureGrid";
import { SeoHighlightBox } from "@/components/seo/SeoHighlightBox";
import { PartyPopper, Mic2, Users, Music } from "lucide-react";

const KomikNaImpreze = () => (
  <SeoPageLayout title="Komik" titleAccent="na imprezę firmową">
    <SeoSection title="Impreza firmowa z profesjonalnym komikiem">
      <p>Impreza firmowa to wyjątkowa okazja, by podziękować pracownikom za ich zaangażowanie i stworzyć niezapomniane wspomnienia. Profesjonalny komik nadaje wydarzeniu prestiżowy charakter, a jednocześnie zapewnia autentyczną, dobrą zabawę. To inwestycja w morale zespołu, która procentuje przez miesiące.</p>
    </SeoSection>

    <SeoSection title="Rodzaje imprez firmowych z występem komediowym">
      <SeoStyledList items={[
        "Wigilia firmowa i impreza świąteczna",
        "Impreza noworoczna i karnawałowa",
        "Jubileusz firmy - 5, 10, 25 lat na rynku",
        "Piknik firmowy i family day",
        "After party po konferencji lub szkoleniu",
        "Impreza z okazji osiągnięcia celów sprzedażowych",
        "Powitanie nowego zespołu po fuzji lub restrukturyzacji"
      ]} />
    </SeoSection>

    <SeoSection title="Personalizacja występu pod Twoją firmę">
      <p>Każda firma ma swoją kulturę, legendy i wewnętrzne żarty. Nasz komik potrafi to wykorzystać, tworząc materiał, który rezonuje z Twoim zespołem. Przed występem zbieramy informacje o firmie, pytamy o zabawne sytuacje i charakterystyczne postacie - dzięki temu show jest autentyczny i wyjątkowo trafny.</p>
    </SeoSection>

    <SeoSection title="Komik jako prowadzący imprezę">
      <p>Poza samym występem komediowym, nasi artyści mogą poprowadzić całą imprezę firmową. Komik jako MC (Master of Ceremonies) zapewnia spójność programu, płynne przejścia między punktami wieczoru i utrzymuje energię gości na wysokim poziomie przez całe wydarzenie.</p>
    </SeoSection>

    <SeoSection title="Dlaczego warto postawić na komika zamiast DJ-a?">
      <SeoFeatureGrid features={[
        { icon: Mic2, title: "Wspólne doświadczenie", description: "Występ komediowy jednoczy ludzi i daje temat do rozmów." },
        { icon: Users, title: "Budowanie relacji", description: "Śmiech tworzy wspólne wspomnienia, które integrują zespół." },
        { icon: PartyPopper, title: "Idealny duet", description: "Komik na początek wieczoru, DJ dalej - gwarancja udanej imprezy." },
        { icon: Music, title: "Pełna rozrywka", description: "Połączenie stand-upu z muzyką to recepta na niezapomnianą noc." },
      ]} />
    </SeoSection>
  </SeoPageLayout>
);

export default KomikNaImpreze;
